require('../../../lib/ngStorage/ngStorage.min.js');
require('../../candidates/search/jv.search.filter.directive.webpack');
require('../../candidates/search/jv.search.filter-transforms.service');
require('../../candidates/search/jv.search.serializer.service');
require('../../common/jv.Filters.webpack');
require('../../common/directives/jv.pagination.directive');

angular.module('jv.Reqs.List.app', [
  'jv',
  'JV.Core.Directives',
  'ngRoute',
  'ngStorage',
  'jv.requisition.index.controller',
  'jv.search.filter.directive',
  'jv.search.filter-transforms.service',
  'jv.search.serializer.service',
  'jv.Common.Filters',
  'jv.common.pagination.directive'
]).config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider) {
    // $routeChangeSuccess listener will use this below
    $routeProvider.when('/q/:query', { controller: 'ReqsIndexCtrl'});
    $routeProvider.when('/', { controller: 'ReqsIndexCtrl'});
    $locationProvider.hashPrefix('');
}]);
